module.exports = {"experienceCloud":"Experience Cloud","touDialogCancelLabel":"Atualizar conteúdo","touDialogConfirmLabel":"Fazer logon e aceitar os termos","touDialogTitle":"Termos de uso da Adobe Experience Cloud","touTextLine1":"Os Termos de uso da Adobe Experience Cloud foram atualizados.","touTextLine2a":"Faça logon na","touTextLine2b":"e aceite os termos de uso atualizados antes de prosseguir.","touTextLine3":"Após aceitar os termos, clique em Atualizar conteúdo."}


//////////////////
// WEBPACK FOOTER
// ./src/components/TermsOfUseDialog/__localization__/TermsOfUseDialog/pt_br.json
// module id = 920
// module chunks = 0